var path = 'app/scripts/modules/core/src/projects/dashboard/cluster/inconsistentBuilds.tooltip.html';
var html = "<span ng-repeat=\"build in application.regions[region].inconsistentBuilds\">\n  Build #{{build.buildNumber}}: deployed {{build.deployed | relativeTime }}\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;